import "core-js/modules/es.array.concat.js";

/**
 * 获取下个月的日期
 * @returns {Date}
 */
export function getNextMonth() {
  var d = new Date();
  d.setMonth(d.getMonth() + 2);
  d.setDate(d.getDate() - 1);
  var yy1 = d.getFullYear();
  var mm1 = d.getMonth();
  var dd1 = d.getDate();
  return new Date(yy1, mm1, dd1);
}
/**
 * 获取当前日期字符串
 * @returns {string}
 */

export function getNow() {
  var d = new Date();
  var yy1 = d.getFullYear();
  var mm1 = d.getMonth() + 1;

  if (mm1 < 10) {
    mm1 = '0' + mm1;
  }

  var dd1 = d.getDate();

  if (dd1 < 10) {
    dd1 = '0' + dd1;
  }

  return yy1 + '-' + mm1 + '-' + dd1;
}
/**
 * 格式化日期
 * @param date
 * @returns {string}
 */

export function formatDate(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();

  if (month < 10) {
    month = '0' + month;
  }

  if (day < 10) {
    day = '0' + day;
  }

  return "".concat(year, "-").concat(month, "-").concat(day);
}
export function getTime() {
  var time = new Date();
  var hours = time.getHours();
  var state = '';

  if (hours >= 0 && hours <= 10) {
    state = "早上好";
  } else if (hours > 10 && hours <= 14) {
    state = "中午好";
  } else if (hours > 14 && hours <= 18) {
    state = "下午好";
  } else if (hours > 18 && hours <= 24) {
    state = "晚上好";
  }

  return state;
}